import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { FormBuilder, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-flex-config-dialog',
  templateUrl: './flex-config-dialog.component.html',
  styleUrls: ['./flex-config-dialog.component.scss']
})
export class FlexConfigDialogComponent {
  constructor(  @Inject(MAT_DIALOG_DATA) public data: any,
                public dialogRef: MatDialogRef<FlexConfigDialogComponent>,
                private translateService: TranslateService,
                private domSanitizer: DomSanitizer,
                private formBuilder: FormBuilder,
                private matIconRegistry: MatIconRegistry) { 
      this.matIconRegistry.addSvgIcon(
        'trash_can',
        this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/trash.svg")
      );
  }

  showFormError: boolean = false;
	errMsg: string = "";
	errMsgStyle: any = { 'max-width': '500px' };
  flexForm = this.formBuilder.group ({
    webId: ['', [Validators.required]],
    username: ['', [Validators.required]],
    password: ['', [Validators.required]]
  });

  onRemoveIntegration()
	{
		console.log("Remove the integration - when successful, close the dialog");
		let result = 
		{
			remove: true,
			//is there anything else?
		}
		this.dialogRef.close( result);
	}

	onSave(event)
	{	
    this.showFormError = false;
    const tagBody = this.getConfiguration();
		console.log("Save the changes to the integration - when successful, close the dialog", tagBody);
			return this.data.product.service.updateFlexConfiguration(this.data.account.accountId, tagBody).then( done => {
			//do the rest of the account set up
				let result = 
				{
					setupComplete: true,
				}
				this.dialogRef.close( result);
			})
			.catch(err => {
        this.errMsg = this.translateService.instant('integrations.miteam-config.generic-flex-error');
        this.showFormError = true;
			});
  }

  getConfiguration() {
    let object: any = {
      webId: this.flexForm.controls['webId'].value.trim(),
      username: this.flexForm.controls['username'].value.trim(),
      password: this.flexForm.controls['password'].value.trim()
    };
    return object;
  }
}
